module.exports = __webpack_public_path__ + "static/img/user_info_blue.5649b81.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_info_blue.svg
// module id = EEDj
// module chunks = 1